<template>
    <table class="table timeline-details-content">
        <tbody>
        <column-row v-for="(row, rowIndex) in table.data" :row="row" :columns="1" :key="rowIndex">
            <template slot-scope="{row: {attribute, value}}">
                <td>
                    <strong>
                        <attribute-name :name="attribute"/>
                    </strong>
                    <div class="text-muted">
                        <pretty-data-render :value="preparedValue({attribute, value})"/>
                    </div>
                </td>
            </template>
        </column-row>
        </tbody>
    </table>
</template>

<script>
    import TimelineMessageModel from '@/common/models/timeline-message-model';
    import AttributeName from './attribute-name';
    import ColumnRow from './column-row';
    import PrettyDataRender from '@/components/pretty-data-render/pretty-data-render';

    export default {
        name: 'one-column-list',
        components: {
            PrettyDataRender,
            AttributeName,
            ColumnRow,
        },
        props: {
            messageType: String,
            table: Object,
        },
        methods: {
            preparedValue({attribute, value}) {
                if (attribute === 'Duration' && this.messageType === TimelineMessageModel.Types.gatewayResponseReceived) {
                    return `${value} ms`;
                }
                return value;
            },
        },
    };
</script>
